import { render, staticRenderFns } from "./ForceBackorder.vue?vue&type=template&id=4c8320f9&"
import script from "./ForceBackorder.vue?vue&type=script&lang=js&"
export * from "./ForceBackorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports